import { Stack } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BackToServiceProviderLink } from '..';
import { Card, InlineNotification } from '../../../../components';
import styles from './SocketBreakingError.module.css';
import { AuthErrorResponseCode } from '../../../../common/types/auth-error-response';

interface SocketBreakingErrorProps {
  errorCode?: AuthErrorResponseCode;
  errorDescription?: string;
}

export const SocketBreakingError = ({ errorCode = AuthErrorResponseCode.SERVER_ERROR, errorDescription }: SocketBreakingErrorProps) => {
  const { t } = useTranslation();

  const errorMessage = t(`form.socketError.INTERNAL_ERROR.text`);

  useEffect(() => {
    const screenreaderDiv = document.querySelector('output.screenreader-text');
    const backToServiceProviderButton: HTMLButtonElement = document.querySelector(
      '#cancel-session'
    ) as HTMLButtonElement;

    if (screenreaderDiv) {
      screenreaderDiv.innerHTML = errorMessage;
    }

    if (backToServiceProviderButton) {
      backToServiceProviderButton.focus();
    }
  }, [errorMessage]);

  return (
    <div {...{ 'data-testid': 'mainError' }}>
      <Card>
        <main className={styles.main}>
          <Stack
            className={styles.errorContainerInner}
            direction="column"
            sx={{
              alignItems: 'center',
              justifyContent: 'center',
              gap: '2rem'
            }}>
            <InlineNotification appearance="error">
              <span>{errorMessage}</span>

              <br></br>
            </InlineNotification>

            <BackToServiceProviderLink
              label={t('form.main.backToServiceProvider')}
              errorCode={errorCode}
              errorDescription={errorDescription}
            />
          </Stack>
        </main>
      </Card>
    </div>
  );
};
